import { useEffect } from 'react';
import { useAppConfigSelector } from '../../redux/selector';

export default function AppLoading() {
  const appConfig = useAppConfigSelector();

  return (
    <div
      className={
        'app-loading absolute top-0 bottom-0 left-0 right-0 bg-[#dddddd5e] z-[9999] ' +
        (appConfig.isLoading ? 'block' : 'hidden')
      }
    >
      <div className="top-[50%] left-[50%] z-10 w-fit absolute translate-x-[-50%] translate-y-[-50%]">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
